document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.wt-product__info').forEach((info) => {
    let actions = info.querySelector('.sh-cladding-actions');
    let sample = actions ? actions.querySelector('.sh-cladding-sample-button') : null;
    const save = info.querySelector('.stonehaus-save-button--product');

    if (!actions && save) {
      sample = Array.from(info.querySelectorAll('.wt-button-section__container a')).find((link) => /^order\s+(a\s+)?samples?$/i.test(link.textContent.trim()));
      if (sample) {
        const sampleWrap = sample.closest('.wt-button-section__container');
        actions = document.createElement('div');
        actions.className = 'sh-cladding-actions';
        sampleWrap.insertAdjacentElement('beforebegin', actions);
        actions.append(sample, save);
        sampleWrap.remove();
      }
    }

    if (!actions || !sample || !save) return;

    actions.classList.add('sh-product-actions');
    sample.classList.add('sh-product-actions__sample');
    const saveLabel = save.querySelector('.stonehaus-save-button__label');
    if (saveLabel) saveLabel.textContent = 'Save Stone';

    let contact = info.querySelector('.question-call-section');
    if (!contact) {
      contact = document.createElement('div');
      contact.className = 'question-call-section';
      const copy = document.createElement('p');
      const phone = document.createElement('a');
      phone.href = 'tel:+61492936000';
      contact.append(copy, phone);
    }

    contact.classList.add('sh-product-actions__contact');
    const copy = contact.querySelector('p');
    const phone = contact.querySelector('a');
    if (copy) copy.textContent = 'Questions about coverage or lead time? We answer the same working day.';
    if (phone) {
      phone.textContent = '0492 93 6000';
      phone.href = 'tel:+61492936000';
    }
    actions.appendChild(contact);
  });
});

/* Stone Haus compact sample tray — Sep 4, 2026 */
(() => {
  const PAGE = '/pages/order-cladding-samples';
  const VARIANT = 49458844565742;
  const KEY = 'stonehaus_sample_tray_v1';
  const MAX = 3;
  if ((location.pathname.replace(/\/+$/, '') || '/') === PAGE) return;

  const css = `
  #shSampleTray[hidden]{display:none!important}#shSampleTray{position:fixed;z-index:90;left:50%;bottom:14px;width:min(920px,calc(100% - 28px));transform:translate(-50%,14px);opacity:0;pointer-events:none;transition:.22s ease;font-family:inherit;color:#fff}#shSampleTray.show{transform:translate(-50%,0);opacity:1;pointer-events:auto}
  .shst-panel{display:grid;grid-template-columns:auto 1fr auto;align-items:center;gap:12px;padding:10px 11px 10px 15px;border:1px solid rgba(255,255,255,.14);border-radius:17px;background:rgba(31,32,30,.97);box-shadow:0 14px 38px rgba(0,0,0,.24);backdrop-filter:blur(12px)}.shst-meta{min-width:108px}.shst-title{display:block;font-size:13px;font-weight:750;line-height:1.15}.shst-count{display:block;margin-top:2px;font-size:11px;color:rgba(255,255,255,.65)}
  .shst-slots{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:7px;min-width:0}.shst-slot{position:relative;display:grid;grid-template-columns:40px 1fr;align-items:center;gap:7px;height:50px;min-width:0;padding:4px 24px 4px 4px;border:1px solid rgba(255,255,255,.18);border-radius:10px;background:rgba(255,255,255,.07);box-sizing:border-box;color:#fff}.shst-slot[data-remove]{font:inherit;text-align:left;cursor:pointer}.shst-empty{grid-template-columns:1fr;place-items:center;padding:4px;border-style:dashed;background:rgba(255,255,255,.035);color:rgba(255,255,255,.45)}.shst-empty span{font-size:10.5px;font-weight:650;white-space:nowrap}.shst-empty b{font-size:15px;font-weight:400;margin-right:4px}.shst-img{width:40px;height:40px;border-radius:7px;object-fit:cover;background:#ddd}.shst-name{overflow:hidden;font-size:11px;font-weight:700;text-overflow:ellipsis;white-space:nowrap}.shst-x{position:absolute;right:6px;top:50%;transform:translateY(-50%);font-size:16px;color:rgba(255,255,255,.7)}
  .shst-actions{display:flex;flex-direction:column;align-items:flex-end;gap:3px;min-width:124px}.shst-add{min-width:124px;min-height:46px;padding:0 16px;border:0;border-radius:11px;background:#B5D1CE;color:#20211f;font:inherit;font-size:12px;font-weight:800;cursor:pointer}.shst-add:disabled{opacity:.55;cursor:default}.shst-status{max-width:165px;min-height:12px;font-size:10px;line-height:1.2;text-align:right;color:rgba(255,255,255,.68)}.shst-status.err{color:#ffd1c5}
  @media(max-width:749px){#shSampleTray{bottom:8px;width:calc(100% - 16px)}.shst-panel{grid-template-columns:1fr auto;grid-template-areas:'meta action' 'slots slots';gap:7px 8px;padding:9px;border-radius:14px}.shst-meta{grid-area:meta;min-width:0}.shst-title{font-size:12px}.shst-count{font-size:10px}.shst-slots{grid-area:slots;gap:5px}.shst-slot{grid-template-columns:34px 1fr;height:43px;padding:4px 19px 4px 4px}.shst-empty{grid-template-columns:1fr;padding:4px}.shst-img{width:34px;height:34px}.shst-name{font-size:9.5px}.shst-x{right:4px;font-size:14px}.shst-empty span{font-size:9px}.shst-actions{grid-area:action;min-width:105px}.shst-add{min-width:105px;min-height:36px;padding:0 10px;font-size:11px}.shst-status{max-width:105px;font-size:8.5px}}
  @media(max-width:420px){.shst-name{display:none}.shst-slot{grid-template-columns:1fr;place-items:center;padding:4px 18px 4px 4px}.shst-img{width:34px;height:34px}.shst-empty b{margin:0}.shst-empty span span{display:none}}
  @media(prefers-reduced-motion:reduce){#shSampleTray{transition:none}}
  `;

  const style = document.createElement('style');
  style.id = 'shSampleTrayStyle';
  style.textContent = css;
  document.head.appendChild(style);

  let samples = [];
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || '[]');
    if (Array.isArray(saved)) {
      saved.forEach((s) => {
        if (!s || !s.title || samples.length >= MAX) return;
        const id = s.handle || s.title;
        if (!samples.some((x) => (x.handle || x.title) === id)) samples.push(s);
      });
    }
  } catch (e) {}

  const tray = document.createElement('aside');
  tray.id = 'shSampleTray';
  tray.hidden = true;
  tray.setAttribute('aria-label', 'Selected stone samples');
  tray.innerHTML = `<div class="shst-panel"><div class="shst-meta"><strong class="shst-title">Your samples</strong><span class="shst-count"></span></div><div class="shst-slots"></div><div class="shst-actions"><button type="button" class="shst-add">Add to cart</button><span class="shst-status" role="status" aria-live="polite"></span></div></div>`;

  let slots, count, add, status;
  const save = () => { try { localStorage.setItem(KEY, JSON.stringify(samples)); } catch (e) {} };
  const say = (text = '', err = false) => { status.textContent = text; status.classList.toggle('err', err); };

  function render() {
    count.textContent = `${samples.length} of ${MAX} selected`;
    slots.innerHTML = '';
    for (let i = 0; i < MAX; i++) {
      const s = samples[i];
      if (s) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'shst-slot';
        button.dataset.remove = s.handle || s.title;
        button.setAttribute('aria-label', `Remove ${s.title} sample`);
        if (s.image) {
          const img = document.createElement('img');
          img.className = 'shst-img'; img.src = s.image; img.alt = ''; img.loading = 'lazy';
          button.appendChild(img);
        }
        const name = document.createElement('span'); name.className = 'shst-name'; name.textContent = s.title;
        const x = document.createElement('span'); x.className = 'shst-x'; x.setAttribute('aria-hidden', 'true'); x.textContent = '×';
        button.append(name, x); slots.appendChild(button);
      } else {
        const empty = document.createElement('div');
        empty.className = 'shst-slot shst-empty';
        empty.innerHTML = `<span><b>+</b><span>Sample ${i + 1}</span></span>`;
        slots.appendChild(empty);
      }
    }
    add.disabled = samples.length === 0;
    add.textContent = 'Add to cart';
    if (samples.length) {
      tray.hidden = false;
      requestAnimationFrame(() => tray.classList.add('show'));
    } else {
      tray.classList.remove('show');
      setTimeout(() => { if (!samples.length) tray.hidden = true; }, 230);
    }
  }

  function currentSample(trigger) {
    const info = trigger.closest('.wt-product__info') || document.querySelector('.wt-product__info');
    const data = info && info.querySelector('[data-saved-stone-button]');
    const title = data && data.getAttribute('data-title');
    if (!title) return null;
    return { title, handle: data.getAttribute('data-handle') || title, url: data.getAttribute('data-url') || location.pathname, image: data.getAttribute('data-image') || '' };
  }

  async function addToCart() {
    if (!samples.length || add.disabled) return;
    add.disabled = true; add.textContent = 'Adding…'; say();
    try {
      const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!cartRes.ok) throw new Error('Cart could not be checked.');
      const cart = await cartRes.json();
      if (cart.items.some((x) => Number(x.variant_id) === VARIANT)) throw new Error('A cladding sample pack is already in your cart.');
      const properties = { '_Sample service': 'Cladding samples' };
      samples.forEach((s, i) => { properties[`Sample ${i + 1}`] = s.title; });
      const res = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: VARIANT, quantity: 1, properties }] })
      });
      if (!res.ok) {
        let msg = 'Samples could not be added.';
        try { const data = await res.json(); msg = data.description || msg; } catch (e) {}
        throw new Error(msg);
      }
      samples = []; try { localStorage.removeItem(KEY); } catch (e) {}
      location.href = (window.routes && window.routes.cart_url) || '/cart';
    } catch (e) {
      add.disabled = false; add.textContent = 'Add to cart'; say(e.message || 'Samples could not be added.', true);
    }
  }

  function init() {
    document.body.appendChild(tray);
    slots = tray.querySelector('.shst-slots'); count = tray.querySelector('.shst-count'); add = tray.querySelector('.shst-add'); status = tray.querySelector('.shst-status');
    add.addEventListener('click', addToCart);
    slots.addEventListener('click', (e) => {
      const remove = e.target.closest('[data-remove]');
      if (!remove) return;
      samples = samples.filter((s) => (s.handle || s.title) !== remove.dataset.remove); save(); say(); render();
    });
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('a.sh-product-actions-inline__sample[href*="/pages/order-cladding-samples"],a.sh-product-actions__sample[href*="/pages/order-cladding-samples"],a.sh-cladding-sample-button[href*="/pages/order-cladding-samples"]');
      if (!trigger) return;
      const s = currentSample(trigger);
      if (!s) return;
      e.preventDefault();
      const id = s.handle || s.title;
      if (samples.some((x) => (x.handle || x.title) === id)) { say('This stone is already selected.'); render(); return; }
      if (samples.length >= MAX) { say('3 samples selected. Remove one to add another.', true); render(); return; }
      samples.push(s); save(); render(); say(`${s.title} added.`);
    });
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();

/* Sample tray UX refinements — Sep 5, 2026 */
(() => {
  const style = document.createElement('style');
  style.textContent = `
    #shSampleTrayV4 .sh4slot.sh4empty {
      border: 2px solid #B5D1CE !important;
      background: rgba(181, 209, 206, .12) !important;
      box-shadow: 0 0 0 1px rgba(181, 209, 206, .16) !important;
      color: #fff !important;
    }
    #shSampleTrayV4 .sh4slot.sh4empty:hover,
    #shSampleTrayV4 .sh4slot.sh4empty:focus-visible {
      background: rgba(181, 209, 206, .22) !important;
      box-shadow: 0 0 0 2px rgba(181, 209, 206, .24) !important;
    }
  `;
  document.head.appendChild(style);

  document.addEventListener('click', (event) => {
    const card = event.target.closest('#shSamplePickerV4 .sh4card[data-title]');
    if (!card || card.disabled) return;
    requestAnimationFrame(() => {
      document.querySelector('#shSamplePickerV4 .sh4close')?.click();
    });
  });
})();

/* Sample tray delivery message — Sep 5, 2026 */
(() => {
  const style = document.createElement('style');
  style.textContent = `
    #shSampleTrayV4 .sh4delivery-note {
      display: block;
      margin-top: 2px;
      font-size: 8.5px;
      line-height: 1.1;
      font-weight: 700;
      color: #B5D1CE;
      white-space: nowrap;
    }
    @media (max-width: 749px) {
      #shSampleTrayV4 .sh4delivery-note { font-size: 8px; }
    }
  `;
  document.head.appendChild(style);

  const addNote = () => {
    const meta = document.querySelector('#shSampleTrayV4 .sh4meta');
    if (!meta) return false;
    if (meta.querySelector('.sh4delivery-note')) return true;
    const note = document.createElement('small');
    note.className = 'sh4delivery-note';
    note.textContent = 'All 3 · same delivery fee';
    meta.appendChild(note);
    return true;
  };

  if (!addNote()) {
    const observer = new MutationObserver(() => {
      if (addNote()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
